import Vue from 'vue';
import store from '@/store';
import * as filters from '@/filters';
import bowser from 'bowser';
import baseFn from '@/utils/base';
import request from '@/api/request';
import router from './router';
import App from './App.vue';
import '@/utils/vant';
import '@/assets/scss/demo1.scss';
import '@/plugins/element';

Vue.config.productionTip = process.env.NODE_ENV === 'development';

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

Vue.use(baseFn);

Vue.prototype.$bowser = bowser;
Vue.prototype.$screenHeight = window.innerHeight;
Vue.prototype.$request = request;

window.addEventListener('resize', () => {
  console.log(111);
});

window.addEventListener('click', () => {
  console.log('click');
});

const ieVersion = Vue.prototype.IEVersion();
if (ieVersion === -1) {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#wj-website');
} else {
  const colors = ['#00a69b', '#c3d714', '#f8b61c', '#ae027e'];
  const data = colors[Math.floor(Math.random() * (colors.length))];
  const hintContainer = document.getElementById('browser-ie-hint-container');
  hintContainer.style.display = 'block';
  hintContainer.querySelector('.version').innerHTML = ieVersion;
  //
  hintContainer.querySelector('.hint__box').style.cssText = `border-color:${data}`;
  hintContainer.querySelector('.mail').style.cssText = `color:${data}`;
}
